import cx from 'classnames';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';

import * as styles from './BottomToolbar.module.scss';

interface IconProps {
  ratio?: number;
  [key: string]: unknown;
}

type ToolSettings = {
  label: string;
  icon: (props: IconProps) => React.ReactNode;
  action: () => void;
};

interface BottomToolbarProps {
  sticky?: boolean;
  children?: React.ReactNode;
  tools?: ToolSettings[];
  className?: string;
}

export function BottomToolbar({sticky = false, tools, children, className}: BottomToolbarProps) {
  const computedClassName = cx(styles.bottomToolbarWrapper, className, {
    [styles.bottomSticky]: sticky,
  });

  if (children) {
    return <div className={computedClassName}>{children}</div>;
  }

  return (
    <div className={computedClassName}>
      {tools?.map(({label, icon: Icon, action}) => (
        <Button
          variant="transparent"
          data-qa-id={`bottom-sticky-toolbar-${label}`}
          className={styles.toolbarItem}
          key={label}
          onClick={action}
        >
          <Icon ratio={0.75} />
          <Typography variant="label" className={styles.toolbarText}>
            {label}
          </Typography>
        </Button>
      ))}
    </div>
  );
}
